/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationDocumentType as CommonUtilitiesApplicationDocumentType } from '../../models/CommonUtilities/application-document-type';
import { LoanFileRequestBaseResponse as ModelsV4ApplicationLoanFileRequestBaseResponse } from '../../models/Models/v4/Application/loan-file-request-base-response';

export interface V4ApplicationPersonalloanApplicationIdFilePost$Plain$Params {
  applicationId: string;
      body?: {
'FileName': string;
'DocumentType': CommonUtilitiesApplicationDocumentType;
'formFiles'?: Array<Blob>;
}
}

export function v4ApplicationPersonalloanApplicationIdFilePost$Plain(http: HttpClient, rootUrl: string, params: V4ApplicationPersonalloanApplicationIdFilePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationLoanFileRequestBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4ApplicationPersonalloanApplicationIdFilePost$Plain.PATH, 'post');
  if (params) {
    rb.path('applicationId', params.applicationId, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV4ApplicationLoanFileRequestBaseResponse>;
    })
  );
}

v4ApplicationPersonalloanApplicationIdFilePost$Plain.PATH = '/v4/application/personalloan/{applicationId}/file';
